import React, { useState } from 'react'
import { C_Section2Data } from '../../constants'
import { useStateContext } from '../../context/ContextProvider'
import { renderText, truncateText } from '../hooks/TextVeiw'
import { C_BentoGrid, C_BentoGridItem } from '../ui/C_BentoGrid'
import SmallButton from '../layout/SmallButton'
import {IoIosCloseCircleOutline} from "../icons"
const C_Section2 = () => {
    const [open, setOpen] = useState(false)
    const [openId, setOpenId] = useState(null)

    const handleClose = () => {
        setOpen(false)
        setOpenId(null)
    }
    const {currentLang}=useStateContext()
    const isAr =currentLang ==="ar"
  return (
    <div className='relative'>
    <section className='container'>
      <C_BentoGrid className="mt-12 md:mt-16 lg:mt-20">
        {C_Section2Data.map((item) => {
            const desc = isAr  && item.description_Ar ? item.description_Ar  : item.description_En;
            return(
    
          <C_BentoGridItem 
            key={item.id}
            image={item.image && item.image}
            video={item.video && item.video}
         onClick={() => {
            setOpen(true)
            setOpenId(item.id)
        }}
            title={isAr ? item.title_Ar : item.title_En}
            description={ desc && truncateText(desc, item.id=== 1? 60 :item.id=== 5 ? 70 : 20)}
            className={item.id === 1 ? "md:col-span-1 md:row-span-2" : 
                      item.id === 4 || item.id === 5   ? "md:col-span-1 md:row-span-2" : "md:col-span-1 md:row-span-1/2"}
            id={item.id}
          />
    ) })}
      </C_BentoGrid>
    </section>
    {open && (
    <div className="fixed inset-0 overFlowCard bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
        <div className="relative  flex lg:pt-16 items-center justify-center w-full max-w-2xl">
            {C_Section2Data.map((item) => (
                item.id === openId && (
                    <div
                        key={item.id}
                        className="flex flex-col w-full max-h-[85vh] md:max-h-[70vh] bg-light-glass1 dark:bg-dark-glass1 border border-light-glassStrock1 backdrop-blur-xl rounded-3xl overflow-hidden"
                    >
                        <div className="flex items-center justify-between p-4 md:p-6 border-b border-light-glassStrock1 dark:border-dark-glassStrock1">
                            <SmallButton 
                                onClick={handleClose}
                                className="text-light-subtitle dark:text-dark-subtitle hover:text-light-title dark:hover:text-dark-title transition-colors"
                            >
                                <IoIosCloseCircleOutline size={30} />
                            </SmallButton>
                            
                            {item.image && (
                                <img 
                                    src={item.image} 
                                    alt={currentLang === "ar" ? item.title_Ar : item.title_En} 
                                    className='w-10 h-10 md:w-12 md:h-12 object-contain' 
                                />
                            )}
                        </div>
                        
                        <div className="flex flex-col flex-1 p-4 md:p-6 overflow-hidden">
                            <h3 className="h5 text-light-title dark:text-dark-title mb-4 text-center md:text-right">
                                {currentLang === "ar" ? item.title_Ar : item.title_En}
                            </h3>
                            
                            <div className="overflow-y-auto flex-1 custom-scrollbar pr-2">
                                <p className="body-3 text-light-subtitle dark:text-dark-subtitle leading-relaxed">
                                    {renderText(currentLang === "ar" ? item.description_Ar : item.description_En)}
                                </p>
                            </div>
                        </div>
                    </div>
                )
            ))}
        </div>
    </div>
)}
</div>
  )
}

export default C_Section2